import React from "react";
import { connect } from "react-redux";
import { ThreeDots } from "react-loader-spinner";
import DataTable from "react-data-table-component";
import InfiniteScroll from "react-infinite-scroll-component";

import { useSpinner } from "../../../../shared/components/hooks";
import { performanceActions } from "../../redux/actions";
import { getInboxReportTableColumns } from "./utility";
import { performanceConstants } from "../../constants";

const InboxConversationExpandedComponent = (props) => {
  const {
    rowData,
    queryString,
    createDateTo,
    createDateFrom,
    allStoresCount,
    inboxConversationDataByBrandId,
    getInboxConversationDataByBrandId,
  } = props;

  //Show spinner until data is fetched
  const spinner = useSpinner();

  const getInboxReportByBrandId = () => {
    getInboxConversationDataByBrandId(
      createDateFrom,
      createDateTo,
      rowData?.brandId,
      inboxConversationDataByBrandId.length,
      queryString.take
    );
  };

  return (
    <div
      id={`scrollableDiv-${rowData?.brandId}`}
      className="nested-table-scroll"
    >
      {spinner(performanceConstants.GET_INBOX_CONVERSATION_DATA_BY_BRAND_ID) &&
      inboxConversationDataByBrandId?.length === 0 ? (
        <div className="d-flex justify-content-center py-3">
          <ThreeDots ariaLabel="loading-indicator" color="#0E8476" />
        </div>
      ) : (
        <InfiniteScroll
          dataLength={inboxConversationDataByBrandId?.length || 0}
          next={getInboxReportByBrandId}
          hasMore={inboxConversationDataByBrandId.length < allStoresCount}
          loader={
            spinner(
              performanceConstants.GET_INBOX_CONVERSATION_DATA_BY_BRAND_ID
            ) && (
              <div className="d-flex justify-content-center py-3">
                <ThreeDots ariaLabel="loading-indicator" color="#0E8476" />
              </div>
            )
          }
          scrollableTarget={`scrollableDiv-${rowData?.brandId}`}
        >
          <DataTable
            dense
            striped
            noHeader
            sortServer
            pagination={false}
            noTableHead={true}
            className="day-table"
            highlightOnHover={false}
            data={inboxConversationDataByBrandId}
            columns={getInboxReportTableColumns(null, true)}
          />
        </InfiniteScroll>
      )}
    </div>
  );
};
//Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  allStoresCount: state.performanceReducer.allStoresCount,
  inboxConversationDataByBrandId:
    state.performanceReducer.inboxConversationDataByBrandId,
});

//Mapping the component's props to the related actions
const mapDispatchToProps = {
  getInboxConversationDataByBrandId:
    performanceActions.getInboxConversationDataByBrandId,
};

//Mapping action and store the function via props
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(React.memo(InboxConversationExpandedComponent));
